import { isEmpty } from '../../../utils/utils';
import { EnumListOrderSortBy, EnumOrderManagementSortField, EnumSortOrder } from '../../../constants/enum';

export const generateServerOrderSort = (sortInfo) => {
  const { sort, sortOrder } = sortInfo;

  if (isEmpty(sort) || isEmpty(sortOrder)) { return null; }

  switch (sort) {
    case EnumOrderManagementSortField.ORDER_CODE.id: {
      if (sortOrder === EnumSortOrder.ASC.id) {
        return EnumListOrderSortBy.ORDER_CODE.id;
      }

      return EnumListOrderSortBy.ORDER_CODE_DESC.id;
    }
    case EnumOrderManagementSortField.DELIVERY_TIME.id: {
      if (sortOrder === EnumSortOrder.ASC.id) {
        return EnumListOrderSortBy.DELIVERY_DATETIME.id;
      }

      return EnumListOrderSortBy.DELIVERY_DATETIME_DESC.id;
    }
    case EnumOrderManagementSortField.TOTAL.id: {
      if (sortOrder === EnumSortOrder.ASC.id) {
        return EnumListOrderSortBy.MERCHANT_PAID_AMOUNT.id;
      }

      return EnumListOrderSortBy.MERCHANT_PAID_AMOUNT_DESC.id;
    }
    case EnumOrderManagementSortField.STATUS.id: {
      if (sortOrder === EnumSortOrder.ASC.id) {
        return EnumListOrderSortBy.STATUS.id;
      }

      return EnumListOrderSortBy.STATUS_DESC.id;
    }
    default: {
      return null;
    }
  }
};


// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/utils.js